module.exports = __webpack_public_path__ + "static/media/image 21.ba4ba8ee.png";